import React, { Component } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Icon,
  CircularProgress,
} from "@material-ui/core";
import Http from "../../../Http";

export default class GuiaComment extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loadingSave: false,
      openForm: false,
      comentario: "",
      id_guia: false,
      comentarios: [],
      sbOpen: false,
      sbMsg: "",
    };
  }

  componentDidMount() {
    this.getInfo(this.props.guia.id);
    this.setState({ id_guia: this.props.guia.id });
  }

  getInfo = async (id_guia) => {
    this.setState({ loadingData: true });
    const Res = await Http.get(`guia-comentario/one/${id_guia}/historial`);
    if (Res && Res.data) {
      this.setState({ comentarios: Res.data });
    }
    this.setState({ loadingData: false });
  };

  componentDidUpdate(prevProps) {
    if (prevProps.guia.id !== this.props.guia.id) {
      this.getInfo(this.props.guia.id);
      this.setState({ id_guia: this.props.guia.id });
    }
  }


  render() {
    const { comentarios, loadingData= false } = this.state;
    return (
      <div>
        {loadingData ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <CircularProgress />
            Cargando
          </div>
        ) : (
          <div>
            {comentarios.length > 0 ? (
              comentarios.map((comment) => (
                <Accordion key={comment.id} disabled={!comment.comentario}>
                  <AccordionSummary
                    expandIcon={
                      comment.comentario ? <Icon>expand_more_icon</Icon> : null
                    }
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <Typography>
                      <strong>
                        {comment.fecha} - {comment.status} - {comment.usuario}
                        {comment.finalizado ?  '- Finalizado' : comment.fecha_proximo_seguimiento ? `- Fecha de Proximo Seguimiento: ${comment.fecha_proximo_seguimiento}` : ''}
                      </strong>
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography>{comment.comentario}</Typography>
                  </AccordionDetails>
                </Accordion>
              ))
            ) : (
              <span>Sin Comentarios</span>
            )}
          </div>
        )}
      </div>
    );
  }
}
